// Rough per-element pixel costs used to pre-estimate each group's rendered
// height for the virtual scroller. They don't need to be exact — only to scale
// with a group's content so the virtualizer's offsets track reality. A flat
// estimate left tall groups badly under-estimated, which produced large scroll
// corrections when scrolling up into them (the "stuck scroll" symptom).
export const GROUP_BASE_HEIGHT = 88;
export const GROUP_ITEM_HEIGHT = 64;
export const GROUP_SUBGROUP_HEADER_HEIGHT = 44;
